export const AUTHENTICATION_RESULTS = 'AuthenticationResults';
export const EXPIRES_AT = 'expiresAt';
export const CHALLENGE_NAME = 'ChallengeName';
export const SESSION = 'session';
export const CHALLENGE_PARAMETERS = 'ChallengeParameters';
